module.exports = __webpack_public_path__ + "assets/img/player-image.7219614d.jpg";